import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';

import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { ParteDetallePage } from '../pages/parte-detalle/parte-detalle'
import { PersonalDetallePage } from '../pages/personal-detalle/personal-detalle'
import { TareaDetallePage } from '../pages/tarea-detalle/tarea-detalle'
import { EncargadoDetallePage } from '../pages/encargado-detalle/encargado-detalle'
import { CuadrillaDetallePage } from '../pages/cuadrilla-detalle/cuadrilla-detalle'
import { FincasDetallePage } from '../pages/fincas-detalle/fincas-detalle'

import { PcTabsPage } from '../pages/pc-tabs/pc-tabs';
import { PartesService } from '../services/partes.services';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule, /*AngularFireDatabase*/ } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AuthProvider } from '../providers/auth/auth';

export const firebaseConfig = {
  apiKey: "AIzaSyBPoUyYz34e4d2bZVKOS_pin4T921cRLUw",
  authDomain: "pccamp-a6cca.firebaseapp.com",
  databaseURL: "https://pccamp-a6cca.firebaseio.com",
  storageBucket: "pccamp-a6cca.appspot.com",
  messagingSenderId: '621926117959'
};

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ParteDetallePage,
    PersonalDetallePage,
    TareaDetallePage,
    EncargadoDetallePage,
    CuadrillaDetallePage,
    FincasDetallePage,
    PcTabsPage,
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {tabsHideOnSubPages: true,}),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    ParteDetallePage,
    PersonalDetallePage,
    TareaDetallePage,
    EncargadoDetallePage,
    CuadrillaDetallePage,
    FincasDetallePage,
    PcTabsPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    PartesService,
    AuthProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts